import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
  Tab,
  Tabs,
} from "@mui/material";
import PageHeader from "../components/PageHeader";
import FixedBottomNavigation from "../components/FixedBottomNavigation";

const TabPanel = ({ children, value, index }) => {
  return (
    <div hidden={value !== index} style={{ width: "100%" }}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};

const cultureCenterList = [
  {
    label: "이마트 문화센터",
    url: "https://m.cultureclub.emart.com/lecture",
  },
  {
    label: "롯데 문화센터",
    url: "https://culture.lotteshopping.com/index.do",
  },
  {
    label: "현대백화점 문화센터",
    url: "https://www.ehyundai.com/mobile/culture/main.do",
  },
  {
    label: "홈플러스 문화센터",
    url: "https://mschool.homeplus.co.kr/",
  },
  {
    label: "도봉지역 아동센터",
    url: "https://hjy.kr/center_mobile/index.php?cId=jj9won",
  },
];

const Culture = () => {
  const [festivals, setFestivals] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [region, setRegion] = useState("전체");
  const [searchTerm, setSearchTerm] = useState("");
  const [tabIndex, setTabIndex] = useState(0); // 탭 상태

  useEffect(() => {
    fetch("/data/cultures.json")
      .then((response) => response.json())
      .then((data) => {
        const mapped = data.records.map((item, index) => ({
          id: index,
          name: item["축제명"],
          startDate: item["축제시작일자"],
          endDate: item["축제종료일자"],
          date: `${item["축제시작일자"]} ~ ${item["축제종료일자"]}`,
          location: item["소재지도로명주소"] || item["개최장소"] || "미확인",
          description: item["축제내용"] || "설명 없음",
          link: item["홈페이지주소"] || "#"
        }));

        // ✅ 최신순 정렬 (축제 시작일 기준 내림차순)
        const sorted = mapped.sort((a, b) => {
          const dateA = new Date(a.startDate);
          const dateB = new Date(b.startDate);
          return dateB - dateA; // 최신 → 오래된 순
        });

        setFestivals(sorted);
        setFiltered(sorted);
      })
      .catch((error) => console.error("Error loading festival data:", error));
  }, []);

  useEffect(() => {
    let filteredData = festivals;

    if (region !== "전체") {
      filteredData = filteredData.filter((f) =>
        f.location.includes(region)
      );
    }

    if (searchTerm.trim() !== "") {
      filteredData = filteredData.filter((f) =>
        f.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFiltered(filteredData);
  }, [region, searchTerm, festivals]);

  const handleRegionChange = (event, newRegion) => {
    if (newRegion !== null) {
      setRegion(newRegion);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };  

  return (
    <Container sx={{ pt: 6, pb: 8,pl:0,pr:0 }}>
      <PageHeader title="문화센터" />
      
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabIndex} onChange={handleTabChange} variant="fullWidth">
          <Tab label="메인" />
          <Tab label="프로그램" />
        </Tabs>
      </Box>

      <TabPanel value={tabIndex} index={0}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {cultureCenterList.map((center, idx) => (
            <Button
              key={idx}
              variant="outlined"
              sx={{
                width: "100%",
                height: 60,
                fontSize: "1em",
                textTransform: "none",
                fontWeight: "bold",
              }}
              onClick={() => window.location.href = center.url}
            >
              {center.label}
            </Button>
          ))}
        </Box>
      </TabPanel>
      
      <TabPanel value={tabIndex} index={1}>
        {/* 🔍 검색 + 지역 필터 */}
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="프로그램 검색"
            variant="outlined"
            size="small"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <ToggleButtonGroup
            value={region}
            exclusive
            onChange={handleRegionChange}
            color="primary"
            fullWidth
          >
            <ToggleButton value="전체">전체</ToggleButton>
            <ToggleButton value="이마트">이마트</ToggleButton>
            <ToggleButton value="백화점">백화점</ToggleButton>
            <ToggleButton value="롯데">롯데마트</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        {/* 📋 리스트 */}
        <Box sx={{ mt: 1 }}>
          {filtered.length === 0 ? (
            <Typography sx={{ mt: 3 }}>검색 결과가 없습니다.</Typography>
          ) : (
            filtered.map((festival) => (
              <Card key={festival.id} sx={{ mb: 1, borderRadius: 2 }}>
                <CardMedia
                  height="100"
                  alt={festival.name}
                />
                <CardContent>
                  <Typography variant="h6">{festival.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    📅 {festival.date}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    📍 {festival.location}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {festival.description}
                  </Typography>
                  {festival.link !== "#" && (
                    <Button
                      size="small"
                      href={festival.link}
                      target="_blank"
                      rel="noopener"
                      sx={{ mt: 1 }}
                    >
                      홈페이지
                    </Button>
                  )}
                </CardContent>
              </Card>
            ))
          )}
        </Box>
      </TabPanel>  
      <FixedBottomNavigation />
    </Container>
  );
};

export default Culture;
